import { DropdownMenu, DropdownMenuContent, DropdownMenuCheckboxItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { SlidersHorizontal } from "lucide-react";

export default function ColumnSelector({ columns, visible, onChange }) {
  const toggle = (key) => {
    const next = { ...visible };
    next[key] = !next[key];
    onChange(next);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="flex items-center gap-1 px-2 py-1 text-[11px] text-[#6B6B6B] border border-[#E0E0DE] rounded-[4px] hover:bg-[#E8E8E6] transition-colors" data-testid="column-selector">
          <SlidersHorizontal className="w-3 h-3" /> Columns
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="bg-white border-[#E0E0DE] shadow-sm min-w-[150px]">
        {columns.map(col => (
          <DropdownMenuCheckboxItem key={col.key} checked={visible[col.key] !== false} onCheckedChange={() => toggle(col.key)}
            className="text-[13px] cursor-pointer" disabled={col.locked}>
            {col.label}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
